// ── ATMVISION Design Tokens ────────────────────────────────────────────────────
// Two complete theme palettes.  Every view imports `useTheme` and calls
//   const C = useTheme()
// at the top of each component function, then uses C.* for all colours.

export const darkTheme = {
  // ── Page structure
  dark:       '#0f1419',
  card:       '#1a2230',
  card2:      '#232d3e',
  cardHover:  '#1e2a3d',
  // ── Brand
  primary:    '#264E72',
  blue:       '#02AFF0',
  orange:     '#F89421',
  // ── Semantic
  green:      '#22c55e',
  red:        '#ef4444',
  yellow:     '#facc15',
  gray:       '#6b7280',
  purple:     '#a855f7',
  // ── Surfaces
  border:     'rgba(255,255,255,0.08)',
  text:       '#e7ecf3',
  muted:      '#8a94a6',
  tint:       'rgba(255,255,255,0.06)',
  overlay:    'rgba(8,16,26,0.82)',
  // ── Mono font (used in Histórico / Rutas)
  mono:       "'JetBrains Mono', monospace",
  // ── Zone palette
  zoneDN:     '#264E72',
  zoneNorte:  '#02AFF0',
  zoneSur:    '#F89421',
  zoneEste:   '#e74c3c',
}

export const lightTheme: typeof darkTheme = {
  // ── Page structure
  dark:       '#eef2f7',
  card:       '#ffffff',
  card2:      '#f4f7fa',
  cardHover:  '#e8eef5',
  // ── Brand (primary stays navy — brand identity)
  primary:    '#264E72',
  blue:       '#0288c2',
  orange:     '#d97706',
  // ── Semantic
  green:      '#16a34a',
  red:        '#dc2626',
  yellow:     '#ca8a04',
  gray:       '#6b7280',
  purple:     '#7c3aed',
  // ── Surfaces
  border:     'rgba(0,0,0,0.10)',
  text:       '#1e2d3d',
  muted:      '#5a7090',
  tint:       'rgba(0,0,0,0.04)',
  overlay:    'rgba(0,0,0,0.55)',
  // ── Mono font
  mono:       "'JetBrains Mono', monospace",
  // ── Zone palette (same brand colours, slightly adjusted for light bg)
  zoneDN:     '#264E72',
  zoneNorte:  '#0288c2',
  zoneSur:    '#d97706',
  zoneEste:   '#dc2626',
}

export type AppTheme = typeof darkTheme
